module.exports = __webpack_public_path__ + "media/images/views-icon-f3643088657d12fb2202f6f6025dac95.png";